import { FC, useState } from 'react'

import styled from 'styled-components'
import { notifications } from '@mantine/notifications'

import Eye from 'src/Assets/eye.svg?react'
import Download from 'src/Assets/download-pc.svg?react'
import { IconButton } from 'src/Components/Button/IconButton.tsx'
import { colors } from 'src/Helpers/constants.ts'
import { DownloadPdfButtonProps } from 'src/Pages/Calculator/DownloadPdfButton.tsx'

const StyledButton = styled(IconButton)`
  background-color: ${colors.secondBlue} !important;

  &:hover {
    background-color: ${colors.secondBlue} !important;
  }
`

const StyledButtonDownload = styled(StyledButton)`
  svg {
    width: 25px;
    height: 25px;
    path {
      stroke: ${colors.white} !important;
    }
  }
`

export const DownloadTakumiPdfButton: FC<DownloadPdfButtonProps> = ({
  disabled,
  ...offerData
}) => {
  const [isRendering, setIsRendering] = useState(false)

  const handleRender = async (action: 'watch' | 'download'): Promise<void> => {
    if (disabled || isRendering) return

    setIsRendering(true)

    let url = ''
    try {
      const { renderOfferPdf } = await import(
        'src/Components/OfferTakumi/render.ts'
      )
      const blob = await renderOfferPdf(offerData)
      url = URL.createObjectURL(blob)

      if (action === 'download') {
        const link = document.createElement('a')
        link.href = url
        link.download = `КП ${offerData.offerNumber || ''}.pdf`.trim()
        link.click()
      } else {
        window.open(url, '_blank')
      }
    } catch {
      notifications.show({
        title: 'Не удалось сформировать КП',
        message: 'Попробуйте ещё раз или обратитесь к администратору',
        color: 'red',
      })
    } finally {
      if (url) setTimeout(() => URL.revokeObjectURL(url), 60000)
      setIsRendering(false)
    }
  }

  const tooltip = (label: string): string => {
    if (disabled) return 'Сохраните КП перед просмотром'

    return isRendering ? 'Формируется…' : label
  }

  return (
    <>
      <StyledButton
        onClick={() => {
          void handleRender('watch')
        }}
        disabled={disabled || isRendering}
        tooltiptext={tooltip('Просмотр КП (новый дизайн)')}
        data-testid='preview-offer-pdf-takumi'
      >
        <Eye />
      </StyledButton>
      <StyledButtonDownload
        onClick={() => {
          void handleRender('download')
        }}
        disabled={disabled || isRendering}
        tooltiptext={tooltip('Скачать КП (новый дизайн)')}
        data-testid='download-offer-pdf-takumi'
      >
        <Download />
      </StyledButtonDownload>
    </>
  )
}
